import React from 'react';
import { Button, Icon, SupportedIconName } from '@gaiads/telia-react-component-library';

interface ArrowButtonProps {
  open: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  dataTestId?: string;
}

const ArrowButton = ({ open, onClick, dataTestId }: ArrowButtonProps) => {
  const iconName = open ? 'chevron-down' : 'chevron-right';
  return (
    <Button variant={'text'} onClick={onClick} data-testid={dataTestId || ''}>
      <Icon name={iconName as SupportedIconName} clickableAppearance={true} size={'sm'} />
    </Button>
  );
};

export default ArrowButton;
